var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('Header'),_c('HomeHead'),_c('router-view',{staticClass:"main_view"}),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }